import * as angular from 'angular';

function filterFunction($filter: ng.IFilterService) {
    var filter = $filter('date');
    return function (input: string) {
        return filter(input, 'MM/yy');
    };
}

angular
    .module('app.common')
    .filter('cardExpirationDate', ['$filter', filterFunction]);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/filters/card-expiration-date.filter.ts